import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import { useState } from 'react'
import { Box, Flex, Text, Image } from 'theme-ui'
import Button from '@/components/Commons/Button'
import MarkdownContent from '@/components/Commons/ModalMarkdownContent'
import PAGES from '@/constants/pages'
import { getBydbAssetLocale } from '@/utils/bydb-market'
import { navigateToBydbPage } from '@/utils/bydb-routes'
import styles from './styles'

const Popup = dynamic(() => import('./popup'), { ssr: false })
const Holding = dynamic(() => import('../Holding'), { ssr: false })

const Landing = ({
  layout,
  locale,
  closed,
}: Pages.BuildYourDreamBag.Landing) => {
  const { subtitle, content, cta, terms } = layout
  const assetLocale = getBydbAssetLocale(locale)

  const router = useRouter()
  const [showLocalePopup, setShowLocalePopup] = useState(locale !== 'us')

  const navigateToSelection = () => {
    const { SELECTION } = PAGES.CLIENT.BYDB
    const { locale: _, ...query } = router.query
    navigateToBydbPage(router, locale, SELECTION, query)
  }

  function navigateToLocale(selectedLocale: string) {
    setShowLocalePopup(false)

    if (selectedLocale === locale) {
      return
    }

    const { LANDING } = PAGES.CLIENT.BYDB
    const { locale: _, ...query } = router.query
    navigateToBydbPage(router, selectedLocale, LANDING, query)
  }

  return (
    <>
      {closed ? (
        <Holding locale={locale} />
      ) : (
        <Box
          sx={styles.background}
          variant="layout.bydb.main"
          data-testid="landing-background-image"
        >
          <>
            <Flex sx={styles.logo}>
              <Image
                src={`/static/images/byds/logo/landing/${assetLocale}.png`}
                width={780}
                height={170}
                alt="TaylorMade Logo"
              />
            </Flex>
            <Box sx={styles.content}>
              <Text
                variant="subtitle"
                sx={styles.title}
                className={locale}
                data-testid="landing-subtitle"
              >
                {subtitle}
              </Text>
              {content.map((text: string, index: number) => (
                <Box
                  sx={styles.summary}
                  key={text}
                  className={locale}
                  data-testid={`landing-content-${index}`}
                >
                  <MarkdownContent key={text} layout={text} />
                </Box>
              ))}
                <Button
                  caption={cta}
                  onClick={navigateToSelection}
                  sx={styles.button}
                  variant="buttons.primary"
                />
                <Text sx={styles.terms} data-testid="landing-terms">
                  <MarkdownContent layout={terms} />
                </Text>
            </Box>
          </>
        </Box>
      )}
      {showLocalePopup && <Popup onSelectLocale={navigateToLocale} />}
    </>
  )
}

export default Landing
